import { useContext } from 'react'
import type { WireInlineBlock } from '../../../api/types'
import { SourceListContext } from './SourceListContext'

interface InlineContentProps {
  children: WireInlineBlock[]
}

export function InlineContent({ children }: InlineContentProps) {
  const sources = useContext(SourceListContext)

  return (
    <>
      {children.map((node, i) => {
        if (node.type === 'span') {
          const cls = [
            node.typography?.includes('text-bold')       ? 'font-bold'                 : '',
            node.typography?.includes('text-italic')     ? 'italic'                    : '',
            node.typography?.includes('text-underline')  ? 'underline'                 : '',
            node.typography?.includes('text-strikethrough') ? 'line-through'           : '',
            node.typography?.includes('text-smallcaps')  ? 'font-variant-small-caps'   : '',
            node.typography?.includes('text-superscript') ? 'align-super text-[0.75em]' : '',
            node.typography?.includes('text-subscript')  ? 'align-sub text-[0.75em]'  : '',
            node.typography?.includes('text-highlight')  ? 'bg-yellow-3'               : '',
            node.typography?.includes('text-code')       ? 'font-mono text-[0.85em]'  : '',
          ].filter(Boolean).join(' ')
          return (
            <span key={i} className={cls || undefined}>
              {node.text}
            </span>
          )
        }

        if (node.type === 'link') {
          return (
            <a
              key={i}
              href={node.url}
              className="text-fg underline"
              target="_blank"
              rel="noreferrer"
            >
              {node.text}
            </a>
          )
        }

        if (node.type === 'citation') {
          const idx = sources.findIndex((s) => s.id === node.sourceId)
          return (
            <sup key={i} className="text-[0.75em] font-semibold text-fg-secondary">
              [{idx >= 0 ? idx + 1 : '?'}]
            </sup>
          )
        }

        return null
      })}
    </>
  )
}
